
// this is a modified comp from 'CreateMedicineForm'
<template lang="pug">
  div.modal
    div.modal-dialog
      div.modal-content
        div.modal-body
          p(v-if="medicineType === 'control'") 新增管制藥組
          p(v-if="medicineType === 'combo'") 新增套藥
            span.icon-right(@click="$emit('closeForm')") X
          hr
          form.form-row(@submit.prevent="addDrug")
            div.input-group.col-5
              div.input-group-prepend
                span.input-group-text 代稱*
              input.form-control(v-model="code" placeholder="")
            div.input-group.col-5
              div.input-group-prepend
                span.input-group-text 全名*
              input.form-control(v-model="genericName" placeholder="")
            button.btn.btn-secondary.float-right(
              :disabled="formComplete === false"
              type="submit"
            ) 新增
            
</template>

<script>
export default {
  name: 'CreateMedicineForm',
  props: [
    'medicineType',
  ],
  data() {
    return {
      code: null,
      genericName: null,
      productName: '',
      packageCode1: '',
      packageCode2: '',
      CGMHNumber: null,
      restrainedClass: 0,
      packContent: 0,
    };
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    formComplete() {
      if (this.genericName === null || this.genericName === '') return false;
      if (this.code === null || this.code === '') return false;
      // if (this.CGMHNumber === null) return false;
      return true;
    },
  },
  methods: {
    checkMedWithSameCGMHNumber(CGMHNumber) {
      this.instance.get('/api/medication/', {
        params: {
          CGMH_number: CGMHNumber,
        },
      })
      .then((res) => {
        if (res.data.results.length > 0) {
          return true;
        }
        return false;
      });
    },
    addDrug() {
      const newDrug = {
        type: this.medicineType,
        code: this.code,
        CGMH_number: null,
        // package_code: null,
        package_code2: null,
        generic_name: this.genericName,
        product_name: null,
        // chinese_name: '',
        // content_amount: null,
        // content_unit: '',
        // content_amount_divider: null,
        // content_unit_divider: '',
        // content_percent: null,
        // dosage_unit: '',
        // dose_unit: '',
        // total_content_amount: null,
        // total_content_unit: '',
        pack_content: 0,
        restrained_class: this.medicineType === 'control' ? 1 : 0,
        // return_stock: null,
        // return_when_empty: null,
        // rx_check: null,
        // inventory_type: null,
        // drug_picture_1: null,
        // drug_picture_2: null,
        // drug_box_picture: null,
        // group: [],
      };
      this.instance.get('/api/medication/', {
        params: {
          has_code: this.code,
        },
      })
      .then((res) => {
        if (res.data.results.length === 0) {
          this.instance.post('/api/medication/', newDrug)
            .then(() => {
              this.$store.commit('SET_MESSAGE', {
                type: 'success',
                context: '新增成功',
              });
              this.$emit('dataCreated');
              this.$parent.$refs.vuetable.refresh();
            })
            .catch((err) => {
              this.$store.commit('SET_MESSAGE', {
                type: 'error',
                context: err.response.data,
              });
            });
        } else {
          this.$store.commit('SET_MESSAGE', {
            type: 'warn',
            context: '藥碼重複，請重新確認',
          });
        }
      });
    },
  },
  watch: {
    restrainedClass(val) {
      if (isNaN(val)) {
        this.restrainedClass = 0;
      } else {
        this.restrainedClass = parseInt(val, 10);
      }
    },
    packContent(val) {
      if (isNaN(val)) {
        this.packContent = 0;
      } else {
        this.packContent = parseInt(val, 10);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// CreateSpecialMedicineForm.vue?f5778356